// SHOPPING CART
export const getCreditCardInfo = (state) => state.shopping.payment.creditCard;
export const getShoppingCart = (state) => state.shopping.cart;
export const getFirstSelctedProduct = (state) => {
  const cart =  getShoppingCart(state);
  return cart[0];
};
